"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NavLogo;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _primaryNavContext = require("./primary-nav-context.js");
var _image = require("@site/pattern-library-core/image");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-len */

const Logo = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "Logo",
  class: "pl-l1bj9nix"
});
const Country = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Country",
  class: "pl-c1e7oo2b"
});

/**
 * NavLogo component.
 *
 * @param {Object} props React props
 * @param {string} props.className CSS class name to apply to the outer element
 * @param {string} props.href Url
 * @param {object} props.logos for generating mobile or desktop pl logo
 * @param {string} props.market Current market. Required.
 * @param {string} props.country Current country name. Required.
 * @param {object} props.messages An object with i18n strings. Required.
 * @param {boolean} props.showCountryNameOnLogo if true, and not US market, country label on logo will be generated
 * @param {string} props.spanClass CSS class name to apply to inner span element
 * @param {object} props.urlArgs An object with arguments being passed to Link component to generate correct href. Required.
 * @returns {React.ReactElement} Selectors layout
 * @public
 */
function NavLogo({
  showCountryNameOnLogo,
  href,
  ariaLabel,
  countryName,
  _name,
  mobileImage,
  desktopImage,
  ...rest
}) {
  const {
    privateLabelId
  } = (0, _react.useContext)(_primaryNavContext.PrimaryNavContext);
  const [logo, setLogo] = (0, _react.useState)(null);
  const windowSize = (0, _patternLibraryUtils.useWindowSize)();
  const hardcodedBrands = _patternLibraryUtils.plidMap.GoDaddy === privateLabelId || _patternLibraryUtils.plidMap['123 Reg'] === privateLabelId;

  // GoDaddy: mobile and desktop set using className in hardcoded svg
  // 123 Reg: same mobile and desktop logo
  // All other brands: use mobileImage and desktopImage props
  (0, _react.useEffect)(() => {
    if (!hardcodedBrands) {
      if (windowSize.width > 768) {
        setLogo(/*#__PURE__*/_react.default.createElement(_image.LazyImage, desktopImage));
      } else {
        mobileImage ? setLogo(/*#__PURE__*/_react.default.createElement(_image.LazyImage, mobileImage)) : setLogo(/*#__PURE__*/_react.default.createElement(_image.LazyImage, desktopImage));
      }
    }
  }, [hardcodedBrands, desktopImage, mobileImage, windowSize]);
  return /*#__PURE__*/_react.default.createElement(Logo, (0, _extends2.default)({
    href: href,
    "aria-label": ariaLabel
  }, _patternLibraryUtils.tracking.create(_name, true, false), rest, {
    "data-cy": "nav-logo"
  }), hardcodedBrands ? _patternLibraryUtils.HeaderSVGLogos[privateLabelId] : logo, showCountryNameOnLogo && /*#__PURE__*/_react.default.createElement(Country, null, countryName));
}
NavLogo.propTypes = {
  showCountryNameOnLogo: _propTypes.default.bool,
  href: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  countryName: _propTypes.default.string,
  _name: _propTypes.default.string,
  mobileImage: _propTypes.default.shape({
    height: _propTypes.default.number,
    width: _propTypes.default.number,
    altText: _propTypes.default.string,
    url: _propTypes.default.string
  }),
  desktopImage: _propTypes.default.shape({
    height: _propTypes.default.number,
    width: _propTypes.default.number,
    altText: _propTypes.default.string,
    url: _propTypes.default.string
  })
};